import type { SVGProps } from 'react'

export function TwemojiFlagAustria(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 36 36" {...props}>
      {/* Icon from Twitter Emoji by Twitter - https://creativecommons.org/licenses/by/4.0/ */}
      <path fill="#EEE" d="M0 13h36v10H0z" />
      <path fill="#ED2939" d="M32 5H4a4 4 0 0 0-4 4v4h36V9a4 4 0 0 0-4-4M4 31h28a4 4 0 0 0 4-4v-4H0v4a4 4 0 0 0 4 4" />
    </svg>
  )
}
export default TwemojiFlagAustria
